import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import StoreContext from '../store/Context'
import { isValidToken } from '../utils/customMethods'
import saveUserEvents from '../utils/saveUserEvents'

const Routes = ({
  component: Component,
  isProtected,
  isLogin,
  isRoot,
  ...rest
}) => {
  const dispatch = useDispatch()
  const { token, setToken } = useContext(StoreContext)

  const validateToken = () => {
    const isValid = isValidToken(token)
    
    if (!isValid) {
      dispatch({ type: 'LOGOUT' })
      localStorage.removeItem('token')
      localStorage.removeItem('state')
      setToken(null)
    }else{
      saveUserEvents('pageReload', { page: window.location.pathname }, token)
    }

    return isValid
  }

  return (
    <Route
      {...rest}
      render={() => {
        if (isProtected && !validateToken()) {
          return <Redirect to="/signin" />
        } else if (isLogin && validateToken()) {
          return <Redirect to="/dashboard" />
        } else if (isRoot) {
          return <Redirect to="/dashboard" />
        } else {
          return <Component {...rest} />
        }
      }}
    />
  )
}

export default Routes
